module.exports = __webpack_public_path__ + "static/media/kz.ba53d21a.svg";